
      function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
   updateCartDrawer();
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

function topcals() {
  var progressBar = document.getElementById('cart_shippingThreshold__progress');
  var progressNum = document.getElementById('cart_shipping_num');
  var progressOuter = document.getElementById('cart_shipping__numOuter');
  var successMsg = document.getElementById('cart_shipping__success');
  var currlimit = cartlimitprice;
const current_tot = document.getElementById("sub-total").getAttribute("data-subtot");
  var newProgressNum = (currlimit - current_tot).toFixed(2);
  var result =  Math.round((current_tot / currlimit) * 100);
  // alert(newProgressNum);
  
  document.getElementById('cart_shippingThreshold__progress').style.width = result + "%";
// alert(newProgressNum);
if(currlimit < current_tot){
  successMsg.style.display = 'flex';
  progressOuter.style.display = 'none';
  
}
  else{
    successMsg.style.display = 'none';
    progressOuter.style.display = 'flex';
    document.getElementById('cart_shipping_num').innerHTML=newProgressNum;
  }
  
}


function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
  topcals();



  
}

/* ---------------------------- */
function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll("#gotocartsecs")
    .forEach((el2) => {
      el2.addEventListener("click", () => {
        console.log("opening drawers");
        openCartDrawer();
      });
    });
  
$(document).ready(function(){
  

  
$('.slideshow-container').flickity({

  cellAlign: 'left',
  contain: true,
  adaptiveHeight: true,
  pageDots: true
});




  
}); 




  
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement
            .parentElement;
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );

        
    const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });


 document
    .querySelectorAll(".cart-drawer-quantity-selector-remove-item")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement
            .parentElement;
        const key = rootItem.getAttribute("data-line-item-key");

   


        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: 0 } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });

document
    .querySelectorAll("#savenote")
    .forEach((button) => {
      button.addEventListener("click", async () => {
  console.log("clicked");
const notetext =  document.getElementById("N_ote").value;
  console.log(notetext);
        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ note:  notetext  }),
        });
      const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });

  


  document
    .querySelectorAll(".cart-drawer-header-right-close")
    .forEach((el) => {
      el.addEventListener("click", () => {
        console.log("closing drawer");
        closeCartDrawer();
      });
    });

  document
    .querySelectorAll(".cart-overlay")
    .forEach((el) => {
      el.addEventListener("click", () => {
        console.log("closing drawer");
        closeCartDrawer();
      });
    });




document.querySelectorAll('#toggle').forEach((a) => {
    // e.preventDefault();
    
   var toggleDiv = document.getElementById('target');

    // add a click event listener to the document object
      $(document).on('click', function(event) {
      // check whether the target of the event is inside the toggle div or toggle button
      if (!$(event.target).closest('#toggle, #target').length) {
      // if it is outside, hide the toggle div
      toggleDiv.style.display = 'none';
      }
      });
  
 // add a click event listener to the toggle button
      $('#toggle').on('click', function() {
      // toggle the display of the toggle div
      if (toggleDiv.style.display === 'none') {
      toggleDiv.style.display = 'block';
      } else {
      toggleDiv.style.display = 'none';
      }
  });
  
 }); 


 
  
}
addCartDrawerListeners();


/*!
 * 
 * ------
 * Note: customizing files reduces the store's ability to auto-update the theme.
 *
 * Disclaimer:
 * This is a non minified version of a core js file, you can swap out the liquid / HTML link from the minified file if you choose to utilize this one. Any usage of these files is at the merchant/app/expert/agency's own risk, we take no responsibility for custom code changes. Support offerings from We Are Eight will be limited to rolling back to the latest theme version if these are utilized.
 *
 * License and acceptance of usage:
 *
 * Copyright (C) We Are Eight LTD  - All Rights Reserved
 * This file is part of Influence theme provided for usage on Shopify online stores only.
 * Unauthorized usage and or modification of this file outside of this Influence utilized on a Shopify store without a valid license, is strictly prohibited.
 * Unauthorized copying or distribution of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 *
 * More information and official contact details: weareeight.com
 * ------
 *
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 845:
/***/ ((module) => {

!function(e,d){ true?module.exports=d():0}(self,(function(){return(()=>{"use strict";var e={};return((e,d)=>{Object.defineProperty(d,"__esModule",{value:!0}),d.isArmadaLoaded=void 0,d.isArmadaLoaded=e=>{var d,o;const a=!0===(null===(o=null===(d=window.eight)||void 0===d?void 0:d.armada)||void 0===o?void 0:o.loaded);if(!e)return a;a?e():document.addEventListener("ARMADA:LOADED",e)},d.default=d.isArmadaLoaded})(0,e),e})()}));

/***/ }),

/***/ 808:
/***/ ((module) => {

!function(e,t){ true?module.exports=t():0}(self,(function(){return(()=>{"use strict";var e={};return(()=>{var t=e;Object.defineProperty(t,"__esModule",{value:!0}),t.removeTrapFocus=t.trapFocus=void 0;const o={};t.trapFocus=(e,t=e)=>{const n=Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe")),r=n[0],u=n[n.length-1];o.focusin=t=>{t.target!==e&&t.target!==u&&t.target!==r||document.addEventListener("keydown",o.keydown)},o.focusout=function(){document.removeEventListener("keydown",o.keydown)},o.keydown=function(t){"TAB"===t.code.toUpperCase()&&(t.target!==u||t.shiftKey||(t.preventDefault(),r.focus()),t.target!==e&&t.target!==r||!t.shiftKey||(t.preventDefault(),u.focus()))},document.addEventListener("focusout",o.focusout),document.addEventListener("focusin",o.focusin),t.focus()},t.removeTrapFocus=(e=null)=>{document.removeEventListener("focusin",o.focusin),document.removeEventListener("focusout",o.focusout),document.removeEventListener("keydown",o.keydown),e&&e.focus()}})(),e})()}));

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/* harmony import */ var _weareeight_armada_dist_utils_trapFocus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(808);
/* harmony import */ var _weareeight_armada_dist_utils_trapFocus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_weareeight_armada_dist_utils_trapFocus__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(845);
/* harmony import */ var _weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_1__);



class ToastItem extends HTMLElement {
  constructor() {
    super();
    this.heading = this.querySelector('[data-armada-selector="toast-heading"]');
    this.infoContainer = this.querySelector('[data-armada-selector="toast-info"]');
    this.htmlContainer = this.querySelector('[data-armada-selector="toast-html-container"]');
    this.closeButton = this.querySelector('[data-armada-selector="toast-close"]');
    this.cartItemContainer = this.querySelector('[data-armada-selector="toast-cart-item"]');
    this.animationHeading = this.querySelector('[data-armada-selector="toast-animate-heading"]');
    this.animationContent = this.querySelector('[data-armada-selector="toast-animate-content"]');
    (0,_weareeight_armada_dist_utils_isArmadaLoaded__WEBPACK_IMPORTED_MODULE_1__.isArmadaLoaded)(this.init.bind(this));
  }

  attachEvents() {
    if (this.isDismissible) {
      this.addEventListener('mouseenter', () => this.pauseTimer());
      this.addEventListener('keydown', () => this.pauseTimer());
      this.addEventListener('mouseleave', () => this.resumeTimer());
    }

    this.closeButton.addEventListener('click', () => this.removeToast(this.id));
  }

  init() {
    this.handleMessage(this.message, this.heading);
    this.handleInfo(this.info, this.infoContainer);
    this.handleHtml(this.html, this.htmlContainer);
    this.handleDisplay(this.type, this.cartItemId, this.cartItemContainer);
    window.eight.armada.elementRegistry.register({key: 'component-toast-item', assetPath: '/assets/component-toast-item.js'});
  }

  handleMessage(message, targetElement) {
    if (!message) return;
    // Toast heading and aria label
    targetElement.textContent = message;
    this.setAttribute('aria-label', message);
  }

  handleInfo(info, targetContainer) {
    if (!info) return;
    // Toast additional info
    targetContainer.innerHTML = info;
    targetContainer.classList.add('mt-3');
  }

  handleHtml(html, targetContainer) {
    if (!html) return;
    targetContainer.innerHTML = html;
  }

  handleDisplay(type, cartItemId, cartItemContainer) {
    // If atc, add cart line item content then display toast, otherwise display toast
    if (type == 'atc' && cartItemId && window.eight.getCurrentBreakpoint() != 'sm') {
      this.handleAtcContent(cartItemId, cartItemContainer);
    } else {
      this.displayToast();
    }

    document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});
    
  }

  handleAtcContent(id, container) {
    const selector = `[data-armada-selector="toast-cart-item--${id}"]`;
    window.eight.sectionsEngine.sectionRenderingEngine.fetchSection('?', ['toast-cart-item'], [container], [selector], () => this.displayToast());
  }

  displayToast() {
    this.classList.remove('invisible');
    (0,_weareeight_armada_dist_utils_trapFocus__WEBPACK_IMPORTED_MODULE_0__.trapFocus)(this, this.closeButton);
    this.animateToast();
    this.parentElement.scrollTop = 0; // Prevents scrolling to latest toast
  }

  animateToast() {
    const transformValue = this.isMobile ? '100%' : '-100%';
    const duration = this.isMobile ? 0 : 0;
    const toastAnimation = this.animate(
      [
        { transform: `translateY(${transformValue})` },
        { transform: 'translateY(0%)' }
      ],
      {
        duration: duration,
        easing: 'ease-in-out',
        fill: 'forwards'
      }
    );
    toastAnimation.onfinish = () => {
      this.classList.remove('-z-[1]');
      this.animateHeading();
      this.animateContent();
    }
  }

  animateHeading() {
    if (!this.animationHeading) return;
    const headingAnimation = this.animationHeading.animate(
      [
        { transform: `translateY(20px)`, opacity: 0 },
        { transform: 'translateY(0px)', opacity: 100 }
      ],
      {
        duration: 0,
        easing: 'ease-out',
        fill: 'forwards'
      }
    );
  }

  animateContent() {
    if (!this.animationContent) {
      this.initiateDismissible();
      this.attachEvents();
      return;
    }
    const contentAnimation = this.animationContent.animate(
      [
        { transform: `translateY(20px)`, opacity: 0 },
        { transform: 'translateY(0px)', opacity: 100 }
      ],
      {
        delay: 0,
        duration: 0,
        easing: 'ease-out',
        fill: 'forwards'
      }
    );
    contentAnimation.onfinish = () => {
      setTimeout(() => {
        this.initiateDismissible();
        this.attachEvents();
      }, 0);
    }
  }

  initiateDismissible() {
    if (!this.isDismissible) return;
    this.remainingTime = this.duration;
    this.animateProgressBar();
    this.setTimer();
  }

  animateProgressBar() {
    this.querySelector('progress-bar').setAttribute('data-progress-play', true);
  }

  pauseProgressBar() {
    window.eight.eventsEngine.emit(`${window.eight.constants.events["ARMADA:PROGRESSBAR:PAUSE"]}`, { 'element': this });
  }

  resumeProgressBar() {
    window.eight.eventsEngine.emit(`${window.eight.constants.events["ARMADA:PROGRESSBAR:PLAY"]}`, { 'element': this });
  }

  setTimer() {
    this.startTime = Date.now();
    this.timer = setTimeout(() => {
      this.removeToast(this.id);
    }, this.remainingTime);
  }

  pauseTimer() {
    this.pauseProgressBar();
    clearTimeout(this.timer);
    this.stopTime = Date.now();
    this.remainingTime = this.remainingTime - (this.stopTime - this.startTime);
  }

  resumeTimer() {
    if (!this.stopTime) return;
    this.resumeProgressBar();
    this.setTimer();
  }

  removeToast(id) {
    window.eight.notifications.removeFromList(id);
    (0,_weareeight_armada_dist_utils_trapFocus__WEBPACK_IMPORTED_MODULE_0__.removeTrapFocus)();
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }

  get notification() {
    return window.eight.safeJSONParse(this.getAttribute('notification'));
  }

  get id() {
    return this.notification.id;
  }

  get type() {
    return this.notification.type;
  }

  get message() {
    return this.notification.message;
  }

  get isDismissible() {
    return this.notification.dismissible;
    
  }

  get duration() {
    return this.getAttribute('duration');
  }

  get info() {
    return this.notification.data ? this.notification.data.info : null;
  }

  get cartItemId() {
    return this.notification.data ? this.notification.data.cart_item_id : null;
  }

  get html() {
    return this.notification.data ? this.notification.data.html : null;
  }

  get isMobile() {
    return window.eight.getCurrentBreakpoint() == 'sm';
  }
}

customElements.define('toast-item', ToastItem);

})();

/******/ })()
;



document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

